import './style.css'

import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose, pure, withState } from 'recompose'

import {
  selectors as NotesHistorySelectors,
  actions as NotesHistoryActions,
} from 'data/notesHistory'

import { getLastHistoryVersion } from 'lib/history-utils'
import { selectors as PaymentSelectors } from 'data/payment'
import { goToOrganizationUpgrade } from 'data/ui/actions'

import Header from './Header'
import MainEditor from './MainEditor'
import VersionsList from './Versions/List'
import VersionsNavigator from './Versions/Navigator'
import {
  MainWrapper,
  HeaderWrapper,
  HeaderSideWrapper,
  BodyWrapper,
  Body,
  BodySidePanel,
} from './Layout'

class NotesHistory extends Component {
  componentDidMount() {
    const { fetchNoteHistory, noteId } = this.props
    fetchNoteHistory({ noteId })
  }

  render() {
    const {
      noteId,
      status,
      history,
      setActiveVersionNum,
      revertHistory,
      onModalClose,
      showHistoryDecorators,
      setShowHistoryDecorators,
      isLimited,
    } = this.props

    if (!status || status.get('isLoading')) {
      return (
        <div
          style={{ minWidth: 320 }}
          className="center-text full-width padding-largest"
        >
          Loading ...
        </div>
      )
    }

    if (status.get('hasError')) {
      return (
        <div
          style={{ minWidth: 320 }}
          className="center-text full-width padding-largest"
        >
          Error while loading history
        </div>
      )
    }

    if (history.size === 0) {
      return (
        <div
          style={{ minWidth: 320 }}
          className="center-text full-width padding-largest"
        >
          No history available for this doc
        </div>
      )
    }

    const activeVersionNum =
      this.props.activeVersionNum || getLastHistoryVersion(history).get('to')
    const activeVersion = history.find(
      item => item.get('to') === activeVersionNum
    )
    if (!activeVersion) {
      return null
    }
    return (
      <MainWrapper>
        <HeaderWrapper>
          <HeaderSideWrapper>
            <VersionsNavigator
              activeVersionNum={activeVersionNum}
              history={history}
              setActiveVersionNum={setActiveVersionNum}
            />
          </HeaderSideWrapper>
          <Header
            activeVersion={activeVersion}
            onClose={onModalClose}
            onRevert={() => {
              revertHistory({ noteId, to: activeVersion.get('to') })
              onModalClose()
            }}
            showHistoryDecorators={showHistoryDecorators}
            setShowHistoryDecorators={setShowHistoryDecorators}
          />
        </HeaderWrapper>
        <BodyWrapper>
          <BodySidePanel>
            <VersionsList
              history={history.sortBy(version => -1 * version.get('to'))}
              activeVersionNum={activeVersionNum}
              setActiveVersionNum={setActiveVersionNum}
              isLimited={isLimited}
            />
          </BodySidePanel>
          <Body>
            <MainEditor
              noteId={noteId}
              history={history}
              activeVersionNum={activeVersionNum}
              showHistoryDecorators={showHistoryDecorators}
            />
          </Body>
        </BodyWrapper>
      </MainWrapper>
    )
  }
}

export default compose(
  pure,
  connect(
    (state, { noteId }) => ({
      status: NotesHistorySelectors.getNoteHistoryStatus(state, noteId),
      history: NotesHistorySelectors.getNoteHistory(state, noteId),
      isLimited: PaymentSelectors.isLimited(state),
    }),
    {
      ...NotesHistoryActions,
      goToOrganizationUpgrade,
    }
  ),
  withState('activeVersionNum', 'setActiveVersionNum', null),
  withState('showHistoryDecorators', 'setShowHistoryDecorators', true)
)(NotesHistory)
